export default __webpack_public_path__ + "static/media/curriculum.8b827cf2.jpg";